import React, { useEffect } from 'react';
import { Routes, Route, useNavigate, useLocation, Navigate } from 'react-router-dom';
import { Toaster, toast } from 'react-hot-toast';

import Login from './components/Login';
import Home from './container/Home';
import SettingsPage from './components/SettingsPage';
import AdminPanel from './components/admin/AdminPanel';
import AdminRoute from './components/admin/AdminRoute';

import { UserProvider, useUser } from './context/UserContext';
import { ThemeProvider } from './context/ThemeContext';
import UserDashboard from './components/UserDashboard';
import Registration from './components/Registration';
import ResetPassword from './components/ResetPassword';
import UserNotifications from './components/UserNotifications';

const AppRoutes = () => {
  const { user, loading } = useUser();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const publicRoutes = ['/', '/login', '/feed', '/about', '/privacy-policy', '/terms'];
    const isPublicRoute = publicRoutes.some(route =>
      location.pathname.startsWith(route)
    );

    if (!loading) {
      if (!user && !isPublicRoute) {
        toast.error('You must be logged in to access this feature.');
        navigate('/login');
      }
    }
  }, [loading, user, location, navigate]);

  if (loading) return <div>Loading...</div>;

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Registration />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route
        path="/settings"
        element={user ? <SettingsPage /> : <Navigate to="/register" />}
      />
      <Route
        path="/dashboard"
        element={user ? <UserDashboard /> : <Navigate to="/register" />}
      />
      <Route
        path="/admin"
        element={
          <AdminRoute user={user} loading={loading}>
            <AdminPanel />
          </AdminRoute>
        }
      />
      <Route path="/notifications" element={<UserNotifications user={user} />} />
      <Route path="/*" element={<Home />} />
    </Routes>
  );
};

const App = () => (
  <UserProvider>
    <ThemeProvider>
      <Toaster position="top-right" />
      <AppRoutes />
    </ThemeProvider>
  </UserProvider>
);

export default App;